module.exports = __webpack_public_path__ + "img/John_Julie_Nixon@3x.e253b866.png";